// wang.oa.com 测速上报
import { getPlatformCode } from "@tencent/im-browser";

const isClient =
  typeof window === "object" && window && typeof document !== "undefined";
const isServer = !isClient;
const options = {
  appid: 10028, // appid
  uin: "", // 用户uin
  apn: "unknown", // 用户apn(2g,3g,4g,wifi,unknow)
  platform: getPlatform() // (android,ios,pc)
};

const performancePoints = {
  unloadEventStart: 1,
  unloadEventEnd: 2,
  redirectStart: 3,
  redirectEnd: 4,
  fetchStart: 5,
  domainLookupStart: 6,
  domainLookupEnd: 7,
  connectStart: 8,
  connectEnd: 9,
  requestStart: 10,
  responseStart: 11,
  responseEnd: 12,
  domLoading: 13,
  domInteractive: 14,
  domContentLoadedEventStart: 15,
  domContentLoadedEventEnd: 16,
  domComplete: 17,
  loadEventStart: 18,
  loadEventEnd: 19
};

const customPoints = {
  page_start: 0, // 页面开始时间, 作为自定义点的基准, id为0，不上报
  page_css_ready: 20, // css 加载完成
  page_js_ready: 21, // js 加载完成
  page_main_start: 22, // 主逻辑开始
  page_main_end: 23, // 主逻辑结束
  page_render_end: 24, // 渲染逻辑结束
  page_render_fp: 25 // 首屏渲染结束
};

function calPoints(points, startTime, pointsTime, timeObj) {
  Object.keys(points).forEach(pointName => {
    const index = points[pointName];
    timeObj[index] = pointsTime[pointName]
      ? Math.max(pointsTime[pointName] - startTime, 1)
      : 1;
  });
}

function getPointsTime() {
  const pointsTime = {};
  const capturePoints = window.performance ? window.performance.timing : {};
  // 先算出 performance 中点的时间
  // 再算出自定义点的时间
  calPoints(
    performancePoints,
    capturePoints.navigationStart,
    capturePoints,
    pointsTime
  );
  if (T) {
    calPoints(customPoints, capturePoints.navigationStart, T, pointsTime);
  }
  delete pointsTime[0]; // T.page_start 不用上报
  return pointsTime;
}

function getSpeedParams(pageid) {
  const pointsTime = getPointsTime();
  const ids = pageid.split("-"); // [21931, 1, 2]
  const params = {
    flag1: ids[0],
    flag2: ids[1],
    flag3: ids[2],
    ...pointsTime
  };
  return encodeURIComponent(getUrlParams(params));
}

function getSep(s) {
  return s.indexOf("?") > -1 ? "&" : "?";
}

// android | ios | pc
function getPlatform() {
  const platforms = {
    1: "ios",
    2: "android",
    3: "pc"
  };
  return platforms[getPlatformCode()] || "unknown";
}

// 'param1=xxx&param2=xxx'
// 该方法并不会进行 encodeURIComponent, 避免多次编码
function getUrlParams(opts) {
  let str = "";
  Object.keys(opts).forEach(key => {
    str += `${key}=${opts[key]}&`;
  });
  return str.slice(0, -1);
}

let codeURL = "//report.huatuo.qq.com/code.cgi";
let codeTimer = null;
const codeListMap = {};

export function config(opts) {
  Object.assign(options, opts);

  codeURL = `//report.huatuo.qq.com/code.cgi?${getUrlParams(options)}`;
}

// 参考 wiki http://tapd.oa.com/mhb/markdown_wikis/#1010084921006403623
export function report({
  appid, // 开发者注册的产品id
  pageid, // 表示页面, 如 '21931-1-1'
  platform, // android | ios | pc, 可选, 会自动判断
  speedparams, // 测速点数据
  delay = 1000, // 延迟上报, 默认 1000 ms
  ...others
}) {
  if (isServer) {
    return;
  }
  // 上报数据示例
  // http://report.huatuo.qq.com/report.cgi?appid=10003&speedparams=flag1%3d175%26flag2%3d388%26flag3%3d1%261%3d350%262%3d5000%263%3d12550%264%3d10000%265%3d0%266%3d10000%267%3d8000%268%3d%269%3d0%2610%3d1060%2611%3d5000%2612%3d12620%2613%3d11000%2614%3d0%2615%3d12000%2616%3d11000%2617%3d%2618%3d4000%2619%3d710&apn=2G&device=iphone&platform=ios
  const report = () => {
    let img = new Image();
    const params = getUrlParams({
      appid,
      platform: platform || getPlatform(),
      speedparams: getSpeedParams(pageid),
      ...others
    });
    img.src = `//report.huatuo.qq.com/report.cgi?${params}`;
    img = null;
  };

  delay > 0 ? setTimeout(report, delay) : report();
}

export function addCustomPoints(points) {
  if (!points || typeof points !== "object") {
    return;
  }
  Object.keys(points).forEach(key => {
    customPoints[key] = points[key];
  });
}

export function reportCode({
  delay = 2000, // 延迟上报
  ...data
}) {
  if (isServer) {
    return;
  }

  data = formatCode(data);
  const report = () => {
    let img = new Image();
    const params = getUrlParams(data);
    img.src = `${codeURL}${getSep(codeURL)}${params}`;
    img = null;
  };

  delay > 0 ? batchReportCode(data, delay) : report();
}

function formatCode({
  // domain, // cgi所属域名
  // time, // 耗时
  cgi, // cgi路径
  type, // 成功失败，1成功/2失败/3逻辑失败
  code, // 返回值
  ...others
}) {
  if (!/[1-3]/.test(type)) {
    type = code === 0 ? 1 : code < 600 ? 2 : 3;
  }

  return {
    cgi: encodeURIComponent(cgi),
    type,
    code,
    ...others
  };
}

function batchReportCode(data, delay = 2000) {
  const { domain } = data;

  if (!codeListMap[domain]) {
    codeListMap[domain] = [];
  }

  codeListMap[domain].push(data);
  clearTimeout(codeTimer);
  codeTimer = setTimeout(executeReportCode, delay);
}

function getCodeReportLinks() {
  const links = [];

  // Object.entries(codeListMap).forEach(([k, list]) => {
  for (let k in codeListMap) {
    if (!codeListMap.hasOwnProperty(k)) {
      return;
    }

    const list = codeListMap[k];
    while (list && list.length) {
      const arr = list.splice(0, 10);
      const attrs = ["cgi", "type", "code", "time"];
      let src = `${codeURL}${getSep(codeURL)}domain=${k}&key=${attrs.join(
        ","
      )}`;

      for (let j = 0; j < attrs.length; j++) {
        for (let i = 0; i < arr.length; i++) {
          const item = arr[i];
          src += `&${i + 1}_${j + 1}=${item[attrs[j]]}`;
        }
      }

      src += `&ignoreRandom=${Math.random()}`;

      links.push(src);
    }
  }
  // });

  return links;
}

function executeReportCode() {
  getCodeReportLinks().forEach(src => {
    const img = new Image();
    img.src = src;
  });
}

if (isClient) {
  // 默认配置一下
  config();

  // 确保延迟来不及上报的内容能够上报
  window.addEventListener("unload", executeReportCode, false);
}

export default report;
